import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { useSite } from "@/hooks/content";

// Strong conversion CTA block reused across pages.
export default function CTASection({
  eyebrow = "Get Started",
  title = "Need Help With Workplace or Fire Safety?",
  description = "Speak with SKY about your organisation's safety, compliance, emergency preparedness or training requirements.",
}) {
  const { site, waLink } = useSite();

  return (
    <section className="section-pad" data-testid="cta-section">
      <div className="container-sky">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-navy via-navy to-navy-deep px-6 py-16 sm:px-14 sm:py-20 lg:px-20">
            <div className="pointer-events-none absolute inset-0 bg-blueprint-dark opacity-40" />
            <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-brand/25 blur-[110px]" />
            <div className="pointer-events-none absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-brand-accent/20 blur-[110px]" />

            {/* Arrow motif */}
            <svg className="pointer-events-none absolute right-8 top-8 h-24 w-24 text-brand-light/20 sm:h-40 sm:w-40" viewBox="0 0 100 100" fill="none">
              <path d="M15 75 Q55 70 80 25 M80 25 H55 M80 25 V50" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <div className="relative max-w-2xl">
              <span className="tech-tag text-brand-light">{eyebrow}</span>
              <h2 className="mt-4 font-heading text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
                {title}
              </h2>
              <p className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">{description}</p>
              <div className="mt-9 flex flex-col gap-3.5 sm:flex-row">
                <Link to="/contact" data-testid="cta-section-quote" className="btn-primary-sky !bg-white !text-navy hover:!bg-brand-light">
                  Request a Quote <ArrowUpRight className="h-4 w-4" />
                </Link>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
                  <MessageCircle className="h-4 w-4" /> WhatsApp {site.mobile}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
